// hooks/useBonuses.ts

'use client';

import { useCallback, useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { useAuthStore } from '@/stores/userStore';

export const useBonuses = () => {
  const pathname = usePathname();
  const { setBonuses, account } = useAuthStore();

  const fetchBonuses = useCallback(async () => {
    try {
      const response = await fetch('/api/status-bonuses');
      const data = await response.json();
      if (data.success) {
        setBonuses({
          ...data.bonuses,
          kycLevel: account?.kycLevel,
          kycStatus: account?.kycStatus,
          fullProfile: account?.fullProfile,
        });
      }
    } catch (error) {
      console.warn('Error fetching bonuses:', error);
    }
  }, [account?.kycLevel, account?.kycStatus, account?.fullProfile, setBonuses]);

  useEffect(() => {
    if (!pathname?.includes('/casino/play')) {
      fetchBonuses();
    }
  }, [pathname, fetchBonuses]);

  return { fetchBonuses };
};
